import { connect } from "react-redux";

import { IImportWizardProps, ImportWizard_ } from "../components/import-wizard";
import * as selectors from "../selectors";
import * as actions from "../actions";
import { mapToolsActions } from "~/map";
import * as panelActions from "../../../actions";
import { getImportTemplates, getImportFiles } from "~/file-import/selectors";
import { fetchResurfaceEvents } from "../../../../field-module/actions";
import { getResurfaceEvents } from "~/action-panel/components/field-module/selectors";

const mapStateToProps = (state): Partial<IImportWizardProps> => ({
    isFieldMatchingLoading: selectors.getIsFieldMatchingLoading(state),
    isFieldMatchingComplete: selectors.getIsFieldMatchingComplete(state),
    isLoading: selectors.getIsLoading(state),
    currentStep: selectors.getImportWizardStep(state),
    eventStripCount: selectors.getEventStripCount(state),
    fieldsToResurface: selectors.getFieldsToResurface(state),
    hasSubmitted: selectors.getHasSubmitted(state),
    importFieldStripData: selectors.getImportFieldStripData(state),
    importFieldList: selectors.getImportFieldList(state),
    importFileGuidList: selectors.getImportFileGuidList(state),
    importFiles: getImportFiles(state),
    importType: selectors.getImportWizardType(state),
    ignoreSelectedField: selectors.getIgnoreSelectedField(state),
    isFilteringVisible: selectors.getIsFilteringVisible(state),
    importTemplates: getImportTemplates(state),
    isValidating: selectors.getIsValidating(state),
    showImportPoints: selectors.getShowImportPoints(state),
    isResultsTemplate: selectors.getImportTemplate(state)?.isResultsOnly ?? false,
    resurfaceEvents: getResurfaceEvents(state),
});

const mapDispatchToProps = (dispatch): Partial<IImportWizardProps> => ({
    changeStep: (nextStep) => dispatch(actions.setImportWizardStep(nextStep)),
    closeImportWizard: (isCancel) => dispatch(panelActions.closeImportWizard(isCancel)),
    setFieldBoundarySubmitLoading: (isLoading) => dispatch(actions.setIsLoading(isLoading)),
    submitFieldBoundary: () => dispatch(actions.submitFieldBoundary()),
    setIgnoreSelectedField: (ignoreSelectedField) =>
        dispatch(actions.setIgnoreSelectedField(ignoreSelectedField)),
    setIsFilteringVisible: (isFilteringVisible) =>
        dispatch(actions.setIsFilteringVisible(isFilteringVisible)),
    setShowImportPoints: (showImportPoints) =>
        dispatch(actions.setShowImportPoints(showImportPoints)),
    validateImportEvent: () => dispatch(actions.validateImportEvent()),
    onFetchResurfaceEvents: (fieldGuids, keepExistingEvents) =>
        dispatch(fetchResurfaceEvents(fieldGuids, keepExistingEvents)),
    onSetFieldEditsChanged: () => dispatch(mapToolsActions.setFieldEditsChanged(true)),
    onSetEventsToResurface: (eventsToResurface: string[]) =>
        dispatch(actions.setEventsToResurface(eventsToResurface)),
});

export const ImportWizard = connect(mapStateToProps, mapDispatchToProps)(ImportWizard_);
